import React, {useMemo} from 'react'
import { Header } from './Header/Header'
import { Footer } from './Footer/Footer'
import { Outlet } from 'react-router-dom'
import { ContactSection } from './ContactSection/ContactSection';

export const LandingPage = (prop) => {

  function memo(FunctionComponent) {
    return class MemoizedComponent extends React.PureComponent {
      render() {
        return <FunctionComponent {...this.props} />;
      }
    };
  }


  const Head = memo(Header);
  const Foot = memo(Footer);
  const Contact = memo(ContactSection);

  return (
    <>
      <Head selectedPage={prop.selectedPage} setIsOpen={prop.setIsOpen} setSelectedPage={prop.setSelectedPage}/>
      <Outlet/>
      <Contact />
      <Foot setIsOpen={prop.setIsOpen}/>
    </>
  )
}
